import { handleFirstTab, disableAnimationOnResize } from './lib/lib.js'
import { projectToggles, cards, teamToggles } from './lib/elements.js'
import {
	toggleProjectInfo,
	handleCardClick,
	toggleTeamDescription,
	getDetailsBreakpoint,
} from './lib/handlers.js'

// Remove :focus outline unless user is using the keyboard to navigate
window.addEventListener('keydown', handleFirstTab)

// Disable animations on window resize to improve performace
window.addEventListener('resize', disableAnimationOnResize)

// Handle project toggle clicks
if (projectToggles) {
	projectToggles.forEach((item) => {
		item.addEventListener('click', toggleProjectInfo)
	})
}

if (teamToggles) {
	teamToggles.forEach((item) => {
		item.addEventListener('click', toggleTeamDescription)
	})
}

// Handle card clicks
// cards.forEach((item) => item.addEventListener('click', handleCardClick))

window.addEventListener('resize', getDetailsBreakpoint)
